// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_CarregaDevicesFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/devices_franquias/carrega_devices_franquias
 *
 * Returns the list of messaging devices attached to the franchises in the
 * caller's current filter, each enriched with resolved franchise names and
 * live connection/websocket status from the Evolution API.
 */
import type { DevicesFranquias_CarregaDeviceRow } from './DevicesFranquias_CarregaDeviceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_CarregaDevicesFranquiasResponseDados = DevicesFranquias_CarregaDeviceRow[];

export type DevicesFranquias_CarregaDevicesFranquiasResponse = ApiResponse<DevicesFranquias_CarregaDevicesFranquiasResponseDados>;

registerResponseContract('DevicesFranquias_CarregaDevicesFranquiasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      device_id:         { type: 'number',  required: true },
      franquias_nomes:   { type: 'string',  required: false },
      numero_whatsapp:   { type: 'string',  required: false },
      device_name:       { type: 'string',  required: false },
      device_token:      { type: 'string',  required: false },
      active:            { type: 'boolean', required: false },
      provider_type:     { type: 'string',  required: false },
      connection_status: { type: 'string',  required: false },
      websocket_enabled: { type: 'boolean', required: false },
    },
  },
})
